import { render, staticRenderFns } from "./visi.vue?vue&type=template&id=4ad28a73&"
import script from "./visi.vue?vue&type=script&lang=js&"
export * from "./visi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports